




















































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import * as service from '@/services/prescription';
import { Prop, Watch } from 'vue-property-decorator';
import { getAlterPrescriptionReasons, getReasons } from '@/services/parameters';
import { dateFormat } from '@/helpers/dateFormat';

@Component({
  components: {},
  directives: {}
})
export default class AlterPrescriptionDialog extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  opcaoExcluir;

  dialogFlag = false;
  reasons: any[] = [];
  reason: any = null;
  formOpen = false;
  loadingReasons = false;
  group = [];
  itensSelectGroup = [];
  loadingGroup = false;
  alterDeliveryDate = false;
  multiEnabled = true;

  public $refs!: {
    form: HTMLFormElement;
  };

  public rules: any = {
    reason: [(v) => (!!v && !!v.id) || 'Selecione um motivo']
  };

  public form: any = {
    valid: false
  };

  public beforeMount(): void {
    const filter = {
      idMedico: this.item.medico.id,
      idUnidade: this.item.unidade.id
    };

    this.loadingReasons = true;
    getAlterPrescriptionReasons(filter).subscribe((data) => {
      this.reasons = data.valores || [];
      this.loadingReasons = false;
    });

    this.loadGroup();
  }

  private loadGroup() {
    this.loadingGroup = true;
    service.getAlterPrescriptionGroup(this.item.idPrescricao).subscribe(
      (res) => {
        this.loadingGroup = false;
        this.group = res;
      },
      (error) => {
        this.loadingGroup = false;
        this.showToastApiError(error);
      }
    );
  }

  mounted() {
    this.formOpen = true;
  }

  private getLabelBotaoQtdePresc() {
    if ((this.item && this.item.quantidade && this.item.quantidade > 1) || this.itensSelectGroup.length) {
      return ` ( ${this.item.quantidade * (this.itensSelectGroup.length + 1)} Prescrições )`;
    }
    return '';
  }

  public alterPrescription(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    let idsAlter = Object.assign(new Array(), this.itensSelectGroup.map(i => Number(i.id)));
    idsAlter.push(this.item.idPrescricao);

    let dates = new Array();
    dates.push(this.item.dataPrescricao[0]);
    dates = dates.concat(this.itensSelectGroup.map(i => dateFormat(i.nome, 'ISO-DATE', 'DD/MM/YYYY')));

    this.$emit('alterPrescription', idsAlter, dates, this.reason.id);
  }

  closeForm() {
    this.$emit('close');
    this.dialogFlag = false;
  }

  selectAll() {
    this.itensSelectGroup = this.group.map((g) => g);
  }

  removeAllSelected() {
    this.itensSelectGroup = [];
  }

  @Watch('alterDeliveryDate')
  alterDeliveryDateWatch(v) {
    this.multiEnabled = !v;
    if (v) {
      this.itensSelectGroup = [];
    }
  }
}
